import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Uppercase--Streamline-Flex"
    >
        <desc>{'Uppercase Streamline Icon: https://streamlinehq.com'}</desc>
        <g id="uppercase">
            <path
                id="Union"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M11.5666 7.97081h1.9332c-0.0048 0.18844 -0.0115 0.37732 -0.0199 0.56699 -0.0723 1.6234 -1.0171 2.532 -2.6466 2.532 -1.62941 0 -2.57421 -0.9086 -2.64648 -2.532 -0.03946 -0.88625 -0.03946 -1.54972 0 -2.43595 0.07227 -1.62338 1.01707 -2.53203 2.64648 -2.53203 1.2446 0 2.0898 0.53009 2.4518 1.50385"
                strokeWidth={1}
            />
            <g id="Group 5763">
                <path
                    id="Vector 2"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M0.5 11.0696c0.309307 -1.55349 1.24285 -7.49465 3.09375 -7.49465S6.37819 9.51611 6.6875 11.0696"
                    strokeWidth={1}
                />
                <path
                    id="Vector 3"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M1.03076 8.57129h5.12539"
                    strokeWidth={1}
                />
            </g>
        </g>
    </svg>,
);
